import type { CameraPath } from "@/lib/location-scene-3d/camera-path"
import { promoteRecordedPath } from "@/lib/location-scene-3d/camera-path-spline"

/** Подбор вне кадра. Без Worker — тот же расчёт на следующем тике. */
export function startRecordedPathFit(
  path: CameraPath,
  fov: number,
  epsilon: number,
  onDone: (path: CameraPath | null) => void,
): () => void {
  let settled = false
  let worker: Worker | null = null
  const finish = (fitted: CameraPath | null) => {
    if (settled) return
    settled = true
    onDone(fitted)
  }
  const fallback = () => {
    setTimeout(() => {
      if (settled) return
      try {
        finish(promoteRecordedPath(path, fov, epsilon))
      } catch {
        finish(null)
      }
    }, 0)
  }
  const cancel = () => {
    settled = true
    worker?.terminate()
    worker = null
  }
  if (typeof Worker === "undefined") {
    fallback()
    return cancel
  }
  try {
    worker = new Worker(new URL("./camera-path-fit.worker.ts", import.meta.url), { type: "module" })
    worker.onmessage = (event: MessageEvent<{ path: CameraPath }>) => {
      worker?.terminate()
      worker = null
      finish(event.data.path)
    }
    worker.onerror = () => {
      worker?.terminate()
      worker = null
      fallback()
    }
    worker.postMessage({ path, fov, epsilon })
  } catch {
    worker = null
    fallback()
  }
  return cancel
}
